import { ServiceCaseCreateConfig } from "../service-case-create/service-case-create-config";

export interface ServiceCallsResponse {
    title: string;
    link: string;
    linkTitle: string;
    calls?: Call[];
    noCallsText?: string;
    createCall?: string;
    createCallLink?: string;
    messages: Messages;
    noData?: boolean;
    noDataText?: string;
    isCaseOverviewAllowed: boolean;
    serviceCaseMicroFrontend: ServiceCaseCreateConfig;
}

export interface Messages {
    callId: string;
    lastChange: string;
    details: string;
    timeFormat: string;
    disabledOverviewText: string;
    /** @deprecated */
    unreadChatMessagesText: string;
}

export interface Call {
    title: string;
    machineName: string;
    machineNumber: string;
    status: CallStatus;
    callId: string;
    link: string;
    lastChange: string;
    /** @deprecated */
    unreadChatMessages: number | null;
}

export interface CallStatus {
    type: CallStatusType;
    text: string;
}

export enum CallStatusType {
    TRANSACTION_FAILED = "TransactionFailed",
    OPEN = "Open",
    DELETED = "Deleted",
    CLOSED = "Closed",
    WAITING_FOR_CUSTOMER = "WaitingForCustomer",
    IN_PROCESS = "InProcess",
    CALL_PREDICTIVE = "call-predictive",
    /** @deprecated */
    NEW_MESSAGE = "NewTechMessage",
    ORDER_NUMBER_REQUIRED = "OrderNumberRequired",
    UNREAD_CHAT_MESSAGES = "UnreadChatMessages"
}
